import axios from 'axios';
import { isInternalUser } from './utils';
const IS_DEV = process.env.NODE_ENV !== 'production';
const firehoseURL = 'https://rendition-pmf.vercel.app';
const eventFirehose = '/api/report/event';
const api = axios.create({ baseURL: firehoseURL });
let instance;
export const logEvent = (...args) => {
    if (!instance) {
        throw new Error('You must call init.');
    }
    instance.logEvent(...args);
};
class PMFAnalytics {
    constructor({ appName, apiKey, isDev = IS_DEV, }) {
        this.isDev = true;
        this.appName = appName || '';
        this.apiKey = apiKey;
        this.isDev = isDev;
        api.defaults.headers.common['x-auth-apikey'] = apiKey;
    }
    setAPIKey(key) {
        this.apiKey = key;
    }
    clear() {
        this.appName = '';
        this.setAPIKey('');
    }
    logEvent(eventName, userId, { data, user, }) {
        // Until we fix user auth logic in our code we short circuit if user is not authed
        if (!userId || this.isDev || isInternalUser(userId)) {
            return;
        }
        const modifiedData = Object.assign(Object.assign({}, data), { appName: this.appName });
        const event = {
            userId,
            data: modifiedData,
            name: eventName,
        };
        api
            .post(eventFirehose, {
            event,
            user,
        })
            // eslint-disable-next-line no-console
            .catch(console.error);
    }
}
export const init = (apiKey, opts = {}) => {
    instance = new PMFAnalytics({
        apiKey,
        appName: opts.appName,
        isDev: opts.isDev,
    });
};
